import React, { createContext, useContext } from 'react';

const InvoiceContext = createContext(null);

export const InvoiceProvider = ({ children, questions, invoice, client, setClient, updateInvoice }) => {
    return (
        <InvoiceContext.Provider value={{ questions, invoice, client, setClient, updateInvoice }}>
            {children}
        </InvoiceContext.Provider>
    );
};

export const useInvoiceContext = () => {
    return useContext(InvoiceContext);
};

export default InvoiceContext;

